<par-aem #aemContentContainer class="containerHide"></par-aem>
<div *ngIf="aem.loaded && aem.success">
  <link rel="stylesheet">
  <ng-container *ngTemplateOutlet="productCatlogsTemplate">
  </ng-container>
</div>
<div *ngIf="aem.loaded && !aem.success">
  <div *ngIf="isAuthenticated; then authUnavailable else unAuthUnavailable"></div>
</div>

<ng-template #unAuthUnavailable>
  <p class="warn">We're sorry. Some features of our website are temporarily unavailable.</p>
  <p>You can still sign up for an account <a [routerLink]="[routes.register]">here</a>. If you need additional
    assistance, please contact our customer service department at 800.727.6331.</p>
</ng-template>

<ng-template #authUnavailable>
  <p class="warn">We're sorry. Some features of our website are temporarily unavailable. Feel free to
    continue shopping using the links below. If you need additional assistance, please contact our
    customer service department at 800.727.6331.</p>

  <div>
    <h2>Shop Now</h2>
    <ng-container *ngTemplateOutlet="productCatlogsTemplate">
    </ng-container>
  </div>

  <div>
    <h2>My Account</h2>
    <ng-container *ngTemplateOutlet="myAccountLinksTemplate">
    </ng-container>
  </div>
</ng-template>

<ng-template #productCatlogsTemplate>
  <div *ngIf="productCatlogs.show" class="static-page">
    <mat-grid-list cols="4" rowHeight="8:1">
      <mat-grid-tile *ngFor="let catlog of productCatlogs.catalogs; let i = index">
        <a class="link" (click)="OnCatalogClick(catlog)" id="catalog-label-{{i+1}}">{{catlog.label}}</a>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</ng-template>

<ng-template #myAccountLinksTemplate>
  <mat-grid-list cols="4" rowHeight="8:1" class="static-page">
    <mat-grid-tile *ngFor="let link of myAccountLinks; let i = index">
      <a class="link" [routerLink]="[link.route]" id="link-label-{{i+1}}">{{link.label}}</a>
    </mat-grid-tile>
  </mat-grid-list>
</ng-template>